var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-next",on:{"click":_vm.click}},[_c('i',{staticClass:"el-icon-arrow-right arrow-next-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }